import { StrengthConfig, PasswordRule } from "./types";

export const DEFAULT_STRENGTH_CONFIG: StrengthConfig = {
    0: { label: "", bgColor: "", textColor: "" },
    1: { label: "Too Weak", bgColor: "bg-ERROR", textColor: "text-ERROR" },
    2: { label: "Weak", bgColor: "bg-YELLOW", textColor: "text-YELLOW" },
    3: {
        label: "Strong",
        bgColor: "bg-LIGHT_GREEN",
        textColor: "text-LIGHT_GREEN",
    },
    4: { label: "Very Strong", bgColor: "bg-GREEN", textColor: "text-GREEN" },
};

export const DEFAULT_PASSWORD_RULES: PasswordRule[] = [
    {
        id: "specialChar",
        label: "A Symbol",
        test: (pwd: string) => /[!@#$%^&*(),.?":{}|<>/]/.test(pwd),
        score: 1,
    },
    {
        id: "uppercase",
        label: "An Uppercase Letter",
        test: (pwd: string) => /[A-Z]/.test(pwd),
        score: 1,
    },
    {
        id: "lowercase",
        label: "A Lowercase Letter",
        test: (pwd: string) => /[a-z]/.test(pwd),
        score: 1,
    },
    {
        id: "minLength",
        label: "8 Characters Minimum",
        test: (pwd: string) => pwd.length >= 8,
        score: 1,
    },
    {
        id: "number",
        label: "A Number",
        test: (pwd: string) => /\d/.test(pwd),
        score: 1,
    },

    {
        id: "mediumLength",
        label: "At least 12 characters",
        test: (pwd: string) => pwd.length >= 12,
        score: 1,
        hidden: true,
    },
    {
        id: "longLength",
        label: "At least 16 characters",
        test: (pwd: string) => pwd.length >= 16,
        score: 1,
        hidden: true,
    },
];
